<script>
import PopinInformation from "@/components/popin/PopinInformation.vue";
import HeroSection from "@/components/home/HeroSection.vue";
import SliderHome from "@/components/home/SliderHome.vue";
import StoryBlock from "@/components/home/StoryBlock.vue";
import ShopBlock from "@/components/home/ShopBlock.vue";
import BrasserieBlock from "@/components/home/BrasserieBlock.vue";

export default {
  name: 'HomeBlock',
  components: {BrasserieBlock, ShopBlock, StoryBlock, SliderHome, HeroSection, PopinInformation}
}
</script>

<template>
  <section class="bg-white dark:bg-gray-900 overflow-hidden">
    <div class="py-4 px-4 mb-10 lg:my-32 mx-auto max-w-screen-xl text-center">
      <popin-information  link="/boutique" text="Découvrez notre nouvelle bière"/>
      <hero-section />
    </div>
    <slider-home />
    <story-block />
    <brasserie-block />
    <shop-block />
  </section>
</template>